var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" 页面没有找到 "),_c('a',{attrs:{"href":"/auth.html#/login"}},[_vm._v("登录页面")])])
}]

export { render, staticRenderFns }